var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "newchannelmapping"
  }, [_c('div', {
    staticClass: "animated fadeInDown"
  }, [_c('form', {
    attrs: {
      "autocomplete": "off"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.saveChannelMapping($event)
      }
    }
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('b-card', {
    attrs: {
      "title": _vm.$t('editedjson.addNewChannel')
    }
  }, [_c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "title": "Go To Channel Listing"
    },
    on: {
      "click": _vm.showList
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-left",
    staticStyle: {
      "font-size": "18px",
      "float": "right",
      "margin-top": "-55px",
      "margin-right": "10px",
      "cursor": "pointer"
    },
    attrs: {
      "style": "font-size:18px; float:right; margin-top:-55px; margin-right:10px; cursor:pointer; "
    }
  })]), _vm._v(" "), (_vm.showSelectClient || _vm.showSelectWarehouse) ? _c('div', {
    staticClass: "form-group row"
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('unicommerce.channelmapping.uniwareChannelName')))]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='\tfa fa-cube'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.addChannel.channelname),
      expression: "addChannel.channelname"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('Channelname')
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('unicommerce.channelmapping.uniwareChannelPlaceholder'),
      "name": "Channelname",
      "id": "channelname"
    },
    domProps: {
      "value": (_vm.addChannel.channelname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.addChannel.channelname = $event.target.value
      }
    }
  })]), _vm._v(" "), (_vm.channelErrors.channelname) ? _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.addChannel.channelname.trim() == ''),
      expression: "addChannel.channelname.trim() == ''"
    }],
    staticClass: "text-danger"
  }, [_vm._v("\n                                " + _vm._s(_vm.channelErrors.channelname))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('common.salesChannel')))]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='\tfa fa-cube'></i>"
    }
  }, [_c('basic-select', {
    staticClass: "form-control",
    staticStyle: {
      "height": "32px",
      "padding": "8px",
      "padding-left": "13px",
      "border-radius": "0%"
    },
    attrs: {
      "options": _vm.saleschannellist,
      "name": "saleschannel",
      "placeholder": _vm.$t('orders.salesChannelPlaceHolder'),
      "selected-option": _vm.salesChannelItem
    },
    on: {
      "select": _vm.salesChannelSelected
    }
  })], 1), _vm._v(" "), (_vm.channelErrors.saleschannel) ? _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.addChannel.saleschannel == ''),
      expression: "addChannel.saleschannel == ''"
    }],
    staticClass: "text-danger"
  }, [_vm._v("\n                                " + _vm._s(_vm.channelErrors.saleschannel))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('unicommerce.channelmapping.uniwareWarehouse')))]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='\tfa fa-cube'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.addChannel.uniwarewarehouse),
      expression: "addChannel.uniwarewarehouse"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('Uniware')
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('unicommerce.channelmapping.uniwareWarehousePlaceholder'),
      "name": "Uniware",
      "id": "Uniware"
    },
    domProps: {
      "value": (_vm.addChannel.uniwarewarehouse)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.addChannel.uniwarewarehouse = $event.target.value
      }
    }
  })]), _vm._v(" "), (_vm.channelErrors.uniwarewarehouse) ? _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.addChannel.uniwarewarehouse.trim() == ''),
      expression: "addChannel.uniwarewarehouse.trim() == ''"
    }],
    staticClass: "text-danger"
  }, [_vm._v("\n                                " + _vm._s(_vm.channelErrors.uniwarewarehouse))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('unicommerce.channelmapping.thirdPartyShipping')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-cube'></i>"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.addChannel.thirdpartyshipping),
      expression: "addChannel.thirdpartyshipping"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true,
      'error': _vm.errors.has('ThirdPartyShipping')
    },
    attrs: {
      "name": "ThirdPartyShipping"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.addChannel.thirdpartyshipping = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('unicommerce.channelmapping.thirdPartyShippingPlaceholder')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.yes')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.no')))])])]), _vm._v(" "), (_vm.channelErrors.thirdpartyshipping) ? _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.addChannel.thirdpartyshipping),
      expression: "!addChannel.thirdpartyshipping"
    }],
    staticClass: "text-danger"
  }, [_vm._v("\n                                " + _vm._s(_vm.channelErrors.thirdpartyshipping))]) : _vm._e()], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('unicommerce.channelmapping.specialpackinginstruction')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-cube'></i>"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.addChannel.specialpackinginstruction),
      expression: "addChannel.specialpackinginstruction"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true,
      'error': _vm.errors.has('specialpackinginstruction')
    },
    attrs: {
      "name": "specialpackinginstruction"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.addChannel.specialpackinginstruction = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('unicommerce.channelmapping.specialpackinginstructionPlaceholder')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.yes')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.no')))])])]), _vm._v(" "), (_vm.channelErrors.specialpackinginstruction) ? _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.addChannel.specialpackinginstruction),
      expression: "!addChannel.specialpackinginstruction"
    }],
    staticClass: "text-danger"
  }, [_vm._v("\n                                " + _vm._s(_vm.channelErrors.specialpackinginstruction))]) : _vm._e()], 1)], 1)]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "title": "Alert Message"
    },
    model: {
      value: (_vm.modalMessageShowpo),
      callback: function($$v) {
        _vm.modalMessageShowpo = $$v
      },
      expression: "modalMessageShowpo"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h5', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.$t('inwardList.inward.alertTitle')))]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        _vm.modalMessageShowpo = false
      }
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('i', {
    staticClass: "fa fa-close"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('h6', [_vm._v(" " + _vm._s(_vm.$t('unicommerce.channelmapping.channel')) + " "), _c('b', [_vm._v(_vm._s(_vm.addChannel.channelname))]), _vm._v(" " + _vm._s(_vm.$t('unicommerce.channelmapping.addclient')) + "\n                                    "), _c('b', [_vm._v(_vm._s(_vm.addChannel.clientid))]), _vm._v(" " + _vm._s(_vm.$t('unicommerce.channelmapping.channelmsg')) + "\n                                ")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footerfrm"
  }, [_c('button', {
    staticClass: "btn btn-secondary",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": [_vm.resetForm, function($event) {
        _vm.modalMessageShowpo = false
      }]
    }
  }, [_vm._v(_vm._s(_vm.$t('unicommerce.channelmapping.anotherChannelPopup')))]), _vm._v(" "), _c('router-link', {
    staticClass: "btn-setting d-sm-down-none",
    attrs: {
      "to": 'channelmapping'
    }
  }, [_c('button', {
    staticClass: "btn btn-secondary float-right ",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": _vm.showList
    }
  }, [_vm._v(_vm._s(_vm.$t('unicommerce.channelmapping.goChannelList')))])])], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "channelfooter form-actions"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "disabled": _vm.isLoading,
      "type": "submit"
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  }), _vm._v("\n                        " + _vm._s(_vm.$t('common.saveBtn')))]), _vm._v(" \n                    "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.resetForm
    }
  }, [_c('i', {
    staticClass: "fa fa-ban"
  }), _vm._v("\n                        " + _vm._s(_vm.$t('common.resetBtn')))])])], 1)], 1)])])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-16e8f800", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-16e8f800","hasScoped":true}!./src/views/components/uniware/newchannelmapping/newchannelmapping.component.html
// module id = 1910
// module chunks = 0